import React from 'react';
import { Wrench, Sparkles, ShieldCheck, Clock3 } from 'lucide-react';

export default function PaymentSite() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-blue-900 text-white relative overflow-hidden flex flex-col">
      {/* Ambient glow blobs */}
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-purple-500/30 blur-3xl animate-pulse" />
      <div className="pointer-events-none absolute -bottom-32 -right-24 h-96 w-96 rounded-full bg-blue-500/30 blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }} />
      <div className="pointer-events-none absolute top-1/3 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-indigo-500/20 blur-3xl" />

      {/* Header */}
      <header className="border-b border-white/10 backdrop-blur-sm bg-black/20 relative z-10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-purple-400 to-blue-400 shadow-lg shadow-purple-500/30">
              <Sparkles className="h-5 w-5 text-white" />
            </div>
            <span className="text-lg font-semibold tracking-wide">PanguPlay</span>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="relative z-10 flex flex-1 items-center justify-center px-4 py-16">
        <div className="w-full max-w-lg rounded-3xl border border-white/10 bg-white/5 p-8 sm:p-10 text-center shadow-2xl shadow-black/40 backdrop-blur-md">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-purple-500/20 to-blue-500/20 border border-white/10">
            <Wrench className="h-9 w-9 text-purple-300 animate-[spin_4s_linear_infinite]" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">
            Payment Portal Under Maintenance
          </h1>
          <p className="mt-3 text-white/70 leading-relaxed">
            We're upgrading our payment system to serve you better. Please check
            back shortly &mdash; your subscriptions and transactions remain safe.
          </p>

          {/* Progress indicator */}
          <div className="mt-8">
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/10">
              <div className="h-full w-1/3 rounded-full bg-gradient-to-r from-purple-400 via-indigo-400 to-blue-400 animate-[loading_1.8s_ease-in-out_infinite]" />
            </div>
            <p className="mt-3 text-xs uppercase tracking-widest text-white/40">
              Working on it
            </p>
          </div>

          {/* Trust badges */}
          <div className="mt-8 grid grid-cols-2 gap-3">
            <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-left">
              <ShieldCheck className="h-5 w-5 shrink-0 text-emerald-300" />
              <span className="text-sm text-white/80">Data &amp; payments secure</span>
            </div>
            <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-left">
              <Clock3 className="h-5 w-5 shrink-0 text-blue-300" />
              <span className="text-sm text-white/80">Back online soon</span>
            </div>
          </div>
        </div>
      </main>

      <footer className="relative z-10 pb-6 text-center text-xs text-white/40">
        &copy; {new Date().getFullYear()} PanguPlay. All rights reserved.
      </footer>

      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(150%); }
          100% { transform: translateX(300%); }
        }
      `}</style>
    </div>
  );
}
